<template>
  <v-container>
    <bread-crumbs :items="breadCrumbs"/>

    <v-card class="pa-5">
      <v-row class="mt-6">
        <v-col cols="12" sm="3" md="3" lg="3">
          <label>تاریخ ارائه سرویس</label>
          <date-picker auto-submit v-model="startDate" ></date-picker>
        </v-col>

        <v-col cols="12" sm="3" md="3" lg="3">
          <label>تاریخ پایان سرویس</label>
          <date-picker
            auto-submit
            :min="startDate"
            v-model="endDate"
            :disabled="endDateDisable"
          ></date-picker>
        </v-col>
<!--        <v-col cols="12" sm="3" md="3" lg="3">-->
<!--          <label> تاريخ شروع قرارداد </label>-->
<!--          <date-picker auto-submit v-model="start_bill_date"></date-picker>-->
<!--        </v-col>-->
<!--        <v-col cols="12" sm="3" md="3" lg="3">-->
<!--          <label>تاريخ پایان قرارداد</label>-->
<!--          <date-picker-->
<!--            auto-submit-->
<!--            :min="start_bill_date"-->
<!--            v-model="end_bill_date"-->
<!--            :disabled="endBillDateDisable"-->
<!--          ></date-picker>-->
<!--        </v-col>-->
      </v-row>

      <v-row class="mt-6">
        <v-col cols="12" sm="4" md="3" lg="3">
          <custom-text-field label="شماره قرارداد" v-model="search_contract_number" class="mt-1"/>
        </v-col>
        <v-col cols="12" sm="4" md="3" lg="3">
          <custom-text-field label=" کد مشتری" v-model="search_customer_code" class="mt-1"/>
        </v-col>
        <v-col cols="12" sm="4" md="3" lg="3">
          <custom-text-field label=" نام مشتری" v-model="search_customer_name" class="mt-1"/>
        </v-col>

        <v-col cols="12" sm="2" lg="2" class="d-flex">
          <v-btn
            small
            align="center"
            justify="center"
            class="indigo mt-1 pa-4"
            @click="filter"
          >
            فیلتر
          </v-btn>
          <v-btn
            small
            align="center"
            justify="center"
            class="warning mx-auto mt-1 mr-2 pa-4"
            @click="resetForm"
          >
            <v-icon color="">mdi-refresh-circle</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>


    <v-card class="pt-8 mt-3">
      <h4 class="container-title">لیست صورتحساب های سال مالی 1402 </h4>
      <p class="col-12 text-center font-weight-bold">گزارش سیستم فروش(CRM)</p>
      <p class="col-12 text-center font-weight-bold" v-if="startDate && endDate">برای سال مالی 1402 از تاریخ {{startDate}}  لغایت  {{endDate}}</p>
      <v-row v-if="contractsListData[0]" class="pa-5 pr-10 myBox">

        <p class="col-6"><span>تعداد:</span> <span>{{ contractsListData[0].count }}</span></p>
        <p class="col-6"><span>جمع کل مبلغ فروش:</span> <span>{{ thousandComma(contractsListData[0].totalSell) }}</span>
        </p>
        <p class="col-6"><span>جمع تخفیفات :</span><span>{{ thousandComma(contractsListData[0].totalDiscount) }}</span>
        </p>
        <p class="col-6">
          <span>جمع مالیات :</span><span>{{ thousandComma(contractsListData[0].totalTax) }}</span>
        </p>
<!--        <p class="col-6">-->
<!--          <span>جمع فروش خالص :</span><span>{{ thousandComma(contractsListData[0].total_net_sell) }}</span>-->
<!--        </p>-->
<!--        <p class="col-6">-->
<!--          <span>   جمع فروش و مالیات:</span><span>{{-->
<!--            thousandComma(contractsListData[0].total_sell_and_tax)-->
<!--          }}</span>-->
<!--        </p>-->
        <!--        <p class="col-6">-->
        <!--          <span>جمع فروش خالص به علاوه ارزش افزوده:</span><span>{{-->
        <!--            thousandComma(contractsListData[0].totalSell_and_tax)-->
        <!--          }}</span>-->
        <!--        </p>-->
      </v-row>
      <v-card-text class="pa-5">
        <v-sheet elevation="4" v-if="contractsListData[0]" class="mt-5">

          <v-row class="d-flex mb-5">
            <export-excel
              class="btn btn-default"
              :data="contractsListData[0].contracts"
              :fields="json_fields"
              :title="excelTitle"
              :worksheet="fileName"
              :name="`${fileName}.xls`">

              <v-btn color="indigo darken-1"> خروجی اکسل</v-btn>

            </export-excel>
            <export-excel
              class="btn btn-default"
              :data="secondExcel"
              :fields="json_fields2"
              :title="excelTitle2"
              :worksheet="fileName"
              :name="`${fileName}.xls`">

              <v-btn color="indigo darken-1"> خروجی اکسل اطلاعات کلی</v-btn>

            </export-excel>

            <!--            <v-btn class="btn-default" color="indigo" @click="printPage">پرینت</v-btn>-->
          </v-row>


          <v-data-table
            id="exportTable"
            :headers="headers"
            :items="contractsListData[0].contracts"
            :items-per-page="10"
            class="elevation-3"
            :footer-props="{
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-plus',
        nextIcon: 'mdi-minus',
        itemsPerPageOptions:[10,15]
      }"
          >
            <template v-slot:[`item.show`]="{ item }">

              <v-tooltip bottom class="hand">
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on" small color="primary" class="mr-2 hand"
                    @click="openNewWindow(item)"
                  >
                    mdi-magnify-scan
                  </v-icon>
                </template>
                <span>نمایش فاکتور </span>
              </v-tooltip>
              <!--@click="$router.push({name:'FactorsList',params:{id:item.bill_number}})"-->

            </template>
            <!--            <template v-slot:[`item.has_rack`]="{ item }">-->

            <!--              <v-tooltip bottom class="hand">-->
            <!--                <template v-if="item.has_rack" v-slot:activator="{ on }">-->
            <!--                  <v-icon-->
            <!--                    v-on="on" small color="primary" class="mr-2 hand"-->
            <!--                    @click="openNewWindowRack(item)"-->
            <!--                  >-->
            <!--                    mdi-magnify-scan-->
            <!--                  </v-icon>-->
            <!--                </template>-->
            <!--                <span>نمایش رک </span>-->
            <!--              </v-tooltip>-->
            <!--              &lt;!&ndash;@click="$router.push({name:'FactorsList',params:{id:item.bill_number}})"&ndash;&gt;-->

            <!--            </template>-->
            <template v-slot:[`item.rackList`]="{ item }"><v-icon class="hand" color="primary" @click="handleRouteToRackList(item)">mdi-server</v-icon></template>
            <template v-slot:[`item.date`]="{ item }">{{ // transformDateToJalali(item.date) }}</template>
            <template v-slot:[`item.date`]="{ item }">{{ item.date }}</template>
            <template v-slot:[`item.service_start_date`]="{ item }">{{ new Date(item.service_start_date).toLocaleDateString("en-US") }}</template>
            <template v-slot:[`item.service_end_date`]="{ item }">{{ new Date(item.service_end_date).toLocaleDateString("en-US") }}</template>
<!--            <template v-slot:[`item.service_start_date_shamsi`]="{ item }">{{ transformDateToJalali(item.service_start_date_shamsi) }}</template>-->
<!--            <template v-slot:[`item.service_end_date_shamsi`]="{ item }">{{ transformDateToJalali(item.service_end_date_shamsi) }}</template>-->
            <template v-slot:[`item.service_start_date_shamsi`]="{ item }">{{ item.service_start_date_shamsi }}</template>
            <template v-slot:[`item.service_end_date_shamsi`]="{ item }">{{ item.service_end_date_shamsi }}</template>
<!--            <template v-slot:[`item.rackList`]="{ item }"><v-icon class="hand" color="primary" @click="handleRouteToRackList(item)">mdi-server</v-icon></template>-->
            <template v-slot:[`item.fee`]="{ item }">{{ thousandComma(item.fee) }}</template>
            <template v-slot:[`item.sell`]="{ item }">{{ thousandComma(item.sell) }}</template>
            <template v-slot:[`item.discount`]="{ item }">{{ thousandComma(item.discount) }}</template>
            <template v-slot:[`item.tax`]="{ item }">{{ thousandComma(item.tax) }}</template>
            <template v-slot:[`item.toll`]="{ item }">{{ thousandComma(item.toll) }}</template>
            <template v-slot:[`item.total_price`]="{ item }">{{ thousandComma(item.total_price) }}</template>
            <template v-slot:[`item.net_price`]="{ item }">{{ thousandComma(item.net_price) }}</template>
            <template v-slot:top>
              <v-dialog
                v-model="dialog"
                max-width="1500px"
              >
                <v-card class="pa-2">
                  <v-card-title>
                    <span class="text-h5">لیست رک</span>
                  </v-card-title>


                  <v-card>
                    <v-card-text class="pa-2">
                      <v-sheet elevation="4" >
                        <!--                        <p class="pa-5"><span> نام مشتری:</span>-->
                        <!--                          <span>{{ item.customer_name }}</span>-->
                        <!--                        </p>-->
                        <v-data-table
                          id="detailTable"
                          :headers="detailHeaders"
                          :items="detailItems"
                          :items-per-page="10"
                          class="elevation-3"
                          :footer-props="{
                            showFirstLastPage: true,
                            firstIcon: 'mdi-arrow-collapse-left',
                            lastIcon: 'mdi-arrow-collapse-right',
                            prevIcon: 'mdi-plus',
                            nextIcon: 'mdi-minus',
                            itemsPerPageOptions:[10,15]
                          }">
                        </v-data-table>
                      </v-sheet>
                    </v-card-text>
                  </v-card>

                  <v-card-actions>
                    <v-btn
                      color="blue-darken-1"
                      variant="text"
                      @click="close"
                    >
                      بستن
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
          </v-data-table>
        </v-sheet>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import CustomTextField from "@/components/base/CustomTextField";
import {thousandComma} from "@/plugins/helper";

export default {
  name: "contractList",
  components: {CustomTextField},
  data() {
    return {
      thousandComma,
      page: 1,
      totalUsers: 0,
      numberOfPages: 0,
      loading: true,
      options: {},
      confirmID: null,
      dialog: false,
      dialogConsult: false,
      dialogAdmin: false,
      totalDesserts: 0,
      desserts: [],
      breadCrumbs: [
        {
          text: "داشبورد",
          disabled: false,
          to: {name: "Dashboard"},
          exact: true,
        },
        {
          text: "لیست صورتحساب های سال مالی 1402",
          disabled: true,
          exact: true,
        },
      ],

      detailHeaders: [
        {text: "کد مشتري", value: "customer_code", sortable: true, align: 'center', width: '120px'},
        {text: 'Name', value: 'name', sortable: true, align: 'center', width: '220px'},
        {text: 'Status', value: 'status', sortable: true, width: '100px', align: 'center'},
        {text: 'Tenant', value: 'tenant', sortable: true, align: 'center', width: '220px'},
        {text: 'Role', value: 'role', sortable: true, width: '100px', align: 'center'},
        {text: 'Manufacturer', value: 'manufacturer', sortable: true, width: '150px', align: 'center'},
        {text: 'Type', value: 'type', sortable: true, align: 'center', width: '150px'},
        {text: 'Serial Number', value: 'serial_number', sortable: true, align: 'center', width: '150px'},
        {text: 'Site', value: 'site', sortable: true, align: 'center', width: '180px'},
        {text: 'Rack', value: 'rack', sortable: true, width: '100px', align: 'center'},
        {text: 'Position', value: 'position', sortable: true, width: '120px', align: 'center'},
        {text: 'Rack Face', value: 'rack_face', sortable: true, align: 'center', width: '120px'},
        {text: 'Airflow', value: 'airflow', sortable: true, align: 'center', width: '150px'},
      ],
      headers: [
        {text: "نوع سند", value: "document_type", sortable: false, width: '80px', align: 'center'},
        {text: "شماره", value: "number_", sortable: false, align: 'center'},
        {text: "شماره قرارداد", value: "contract_number", sortable: false, width: '100px', align: 'center'},
        {text: "رک", value: "rackList", sortable: false, align: "center"},
        {text: "تاريخ", value: "date", sortable: false, align: 'center'},
        {text: "كد مشتري", value: "customer_code", sortable: false, width: '100px', align: 'center'},
        {text: "مشتري", value: "customer_name", sortable: false, width: '230px', align: 'center'},
        // {text: "رک", value: "rack", sortable: false},
        // {text: "یونیت", value: "unit", sortable: false},
        {text: "سرور اختصاصی", value: "dedicated_server", sortable: false, width: '120px', align: 'center'},
        {text: "نوع فروش", value: "sell_type", sortable: false, width: '180px', align: 'center'},
        {text: "كد كالا/خدمت", value: "service_code", sortable: false, width: '150', align: 'center'},
        {text: "واحد اصلی", value: "main_unit", sortable: false, width: '100px', align: 'center'},
        {text: "مقدار اصلی", value: "main_quantity", sortable: false, width: '100px', align: 'center'},
        {text: "في", value: "fee", sortable: false, align: 'center'},
        {text: "مبلغ فروش", value: "sell", sortable: false, align: 'center'},
        {text: "تخفيف", value: "discount", sortable: false, align: 'center'},
        {text: "ماليات", value: "tax", sortable: false, align: 'center'},
        {text: "عوارض", value: "toll", sortable: true, align: 'center', width: '100px', align: 'center'},
        {text: "مبلغ کل", value: "total_price", sortable: true, align: 'center'},
        {text: "اضافات", value: "additions", sortable: false, align: 'center'},
        {text: "خالص", value: "net_price", sortable: true, align: 'center'},
        {text: "تاریخ ارائه سرویس شمسی", value: "service_start_date_shamsi", sortable: false, width: '150px', align: 'center'},
        {text: "تاریخ ارائه سرویس میلادی", value: "service_start_date", sortable: true, width: '150px', align: 'center'},
        {text: "تاریخ پایان سرویس شمسی", value: "service_end_date_shamsi", sortable: true, width: '150px', align: 'center'},
        {text: "تاریخ پایان سرویس میلادی", value: "service_end_date", sortable: true, width: '150px', align: 'center'},
        {text: "مدت ارائه سرویس", value: "service_duration", sortable: true, width: '150px', align: 'center'},
      ],

      searchName: '',
      searchMobile: '',
      confirmMethod: null,
      confirmRole: '',
      introductionLetterUrl: '',
      lawDocumentUrl: '',
      confirmStateId: '',
      dialogState: false,
      dialogUserProfile: false,
      dialogNew: false,
      appName: '',
      appId: '',
      search_customer_name: '',
      search_customer_code: '',
      search_contract_number: '',
      start_bill_date: '',
      end_bill_date: '',
      endBillDateDisable:false,
      detailItems: [],


      json_fields: {
        "نوع سند": "document_type",
        "شماره": "number_",
        "شماره قرارداد": "contract_number",
        "تاريخ": {
          field: "date",
          callback: (value) => {
            return this.transformDateToJalali(value)
          }
        },
        "كد مشتري": "customer_code",
        "مشتري": "customer_name",
        "رک": "rack",
        "یونیت": "unit",
        "سرور اختصاصی": "dedicated_server",
        "نوع فروش": "sell_type",
        "كد كالا/خدمت": "service_code",
        "واحد اصلي": "main_unit",
        "مقدار اصلي": "main_quantity",
        "في": "fee",
        "مبلغ فروش": "sell",
        "تخفيف": "discount",
        "ماليات": "tax",
        "عوارض": "toll",
        "مبلغ کل": "total_price",
        "اضافات": "additions",
        "خالص": "net_price",
        "تاریخ ارائه سرویس شمسی": "service_start_date_shamsi",
        //   {
        //   field: "service_start_date_shamsi",
        //   callback: (value) => {
        //     return this.transformDateToJalali(value)
        //   }
        // },
        "تاریخ ارائه سرویس میلادی": {
          field: "service_start_date",
          callback: (value) => {
            return this.transformDateToJalali(value)
          }
        },
        "تاریخ پایان سرویس شمسی": "service_end_date_shamsi",
        //   {
        //   field: "service_end_date_shamsi",
        //   callback: (value) => {
        //     return this.transformDateToJalali(value)
        //   }
        // },
        "تاریخ پایان سرویس میلادی": {
          field: "service_end_date",
          callback: (value) => {
            return this.transformDateToJalali(value)
          }
        },
        "مدت ارائه سرویس": "service_duration",
      },
      json_fields2: {
        '': " ",
        "جمع کل مبلغ فروش": 'totalSell',
        "جمع تخفیفات": 'totalDiscount',
        "جمع مالیات": 'totalTax',
        // "جمع فروش خالص": 'total_net_sell',
        // "جمع فروش و مالیات": 'total_sell_and_tax',
      },
      json_meta: [
        [
          {
            'key': 'charset',
            'value': 'utf-8'
          }
        ]
      ],

      startDate: '',
      endDate: "",
      endDateDisable: false,


    };
  },

  computed: {
    secondExcel: {
      get() {
        return [
          {
            total_sell: this.contractsListData[0].totalSell,
            // total_net_sell: this.contractsListData[0].total_net_sell,
            totalDiscount: this.contractsListData[0].totalDiscount,
            totalTax: this.contractsListData[0].totalTax,
            // total_sell_and_tax: this.contractsListData[0].total_sell_and_tax
          },
          {
            totalSell: "",
            totalBackSell: '',
            totalDiscount: '',
            totalTax: '',
            totalSell_and_tax: ''
          },
          {
            totalSell: "فروش",
            totalBackSell: '',
            totalDiscount: '',
            totalTax: '',
            totalSell_and_tax: 'مدیرعامل'
          }
        ]
      }
    },
    contractsListData: {
      get() {
        return this.$store.getters["company/getContracts1402"];
      },
      set(value) {
      },
    },

    excelTitle: {
      get() {
        return [
          `گزارش سیستم فروش (CRM)`,
          `برای سال مالی 1402`,
          `ار تاریخ ${this.startDate}لغایت  ${this.endDate}`,
        ]
      },
      set(value) {
      },
    },
    excelTitle2: {
      get() {
        return [
          `گزارش سیستم فروش (CRM)`,
          `برای سال مالی 1402`,
          `ار تاریخ ${this.startDate}لغایت  ${this.endDate}`,
          ''
        ]
      },
      set(value) {
      },
    },


    fileName: {
      get() {
        return `contractReport`
        //return `${this.userProfile.firstName} ${this.userProfile.lastName}`
      },
      set(value) {
      },
    },

  },
  watch: {
    // options: {
    //   handler() {
    //     this.readDataFromAPI();
    //   },
    // },
    startDate: {
      handler() {
        console.log(this.startDate)
        console.log('sdfjsdf')
        if (this.startDate != "") {
          this.$store.commit('company/SET_CONTRACTS1402',[])
          this.endDateDisable = false;
          this.endDate = "";
        } else {
          this.endDateDisable = true;
          this.endDate = "";
        }
      },
    },

  },
  async mounted() {
    await this.$store.dispatch('company/fetchContracts1402',{
      year:1402,
      // start_date: this.convertDateToTimestamp(this.startDate),
      // end_date: this.convertDateToTimestamp(this.endDate) + 24 * 3600 * 1000,
      // bill_date_start_date: this.convertDateToTimestamp(this.start_bill_date),
      // bill_date_end_date: this.convertDateToTimestamp(this.end_bill_date)+ 24 * 3600 * 1000,
    })
  },
  methods: {
    checkType(data) {
      return typeof data.item !== "object";
    },

    async readDataFromAPI() {
      this.loading = true;
      const {page, itemsPerPage} = this.options;
      let data = await this.$store.dispatch("app/fetchAppList", {
        page: page,
        count: itemsPerPage,
        // name: this.searchName,

      });
      this.loading = false;
      ////console.log("data.limit", data.limit);
      this.appData = data.docs;
      this.totalUsers = data.totalDocs;
      this.numberOfPages = data.totalPages;
    },


    setIdConfirm(item, method) {
      this.confirmID = item._id;
      this.confirmRole = item.role;
      this.confirmMethod = method;
      this.dialog = true;
    },

    async confirm() {
      this.dialog = false;
      await this.confirmMethod();
      await this.readDataFromAPI();
    },

    async filter() {
      // console.log("filter")
      let temp_date_start = null
      let temp_date_end = null
      if(this.startDate)
        temp_date_start = this.convertDateToTimestamp(this.startDate)
      if(this.endDate)
        temp_date_end = this.convertDateToTimestamp(this.endDate) + 24 * 3600 * 1000
      // this.convertDateToTimestamp(this.startDate),
      await this.$store.dispatch("company/fetchContracts1402", {
        contract_number: this.search_contract_number,
        customer_code: this.search_customer_code,
        customer_name: this.search_customer_name,
        service_start_date: temp_date_start,
        service_end_date: temp_date_end,
        // service_start_date: this.convertDateToTimestamp(this.startDate),
        // service_end_date: this.convertDateToTimestamp(this.endDate) + 24 * 3600 * 1000,
        // year:"1402",
        // contract_start_date: this.convertDateToTimestamp(this.start_bill_date),
        // contract_end_date: this.convertDateToTimestamp(this.end_bill_date)+ 24 * 3600 * 1000,
      });
    },


    resetForm() {
      this.start_bill_date = ''
      this.end_bill_date = ''
      this.startDate = ''
      this.endDate = ''
      this.search_customer_name = ''
      this.search_customer_code = ''
      this.search_bill_number = ''
    },
    transformDateToJalali(value) {
      if (value)
        return moment(value).format('jYYYY/jMM/jDD')
    },
    convertDateToTimestamp(date) {
      return new Date(
        moment(date, "jYYYY/jMM/jDD").format("YYYY/MM/DD")
      ).getTime();
    },
    openNewWindow(item) {
      window.open(`/factors-list/${item.bill_number}`, '_blank')
    },
    openNewWindowRack(item) {
      window.open(`/rack-list/${item.customer_code}`, '_blank')
    },
    printPage() {
      // Get HTML to print from element
      const prtHtml = document.getElementById('exportTable').innerHTML;
      console.log(prtHtml)
// Get all stylesheets HTML
      let stylesHtml = '';
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML;
      }

// Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

      WinPrint.document.write(`${prtHtml}`);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
    async handleRouteToRackList(item){
      this.dialog = true
      this.detailItems = await this.$store.dispatch('company/fetchRacks403', {customer_code: item.customer_code})
      // this.$router.push({name:'RackList403',params:{id:item?.customer_code,name:item.customer_name}})
      //console.log(item)
    },
    close(){
      this.dialog = false
      this.detailItems = []
    }
    /**
     * In a real application this would be a call to fetch() or axios.get()
     */
  },
};
</script>

<style>
.v-text-field__slot input {
  color: black !important;
}

body {
  text-align: right;
}

td {
  /*color: black !important;*/
}

.myBox p {
  border: solid 1px grey;
}
.myBox p span:nth-child(2){
  direction: ltr;
  font-weight: bold;
  text-align: left;
}
</style>
